import Address from '../../AddressBuilder.js'

const _path = {
  SJXXB: Address.business('sjczSjxxb', Address.CONFIG.VERSION.version_1),
}

export default {
  statisticsData(_parameter) {// 统计 sjlbbs[1:登记受理  2：待办  3：已办]  mtbs [0：全部事件]
    return sHttp.postJson(_path.SJXXB + 'statisticsData', _parameter)
  },

  add(_parameter) {// 新增
    return sHttp.postJson(_path.SJXXB + 'sjdj', _parameter)
  },

  update(_parameter) {// 修改
    return sHttp.postJson(_path.SJXXB + 'update', _parameter)
  },

  query(_parameter) {// 查询
    return sHttp.postJson(_path.SJXXB + 'page', _parameter)
  },

  querySldj(_parameter) {// 受理登记-列表
    return sHttp.postJson(_path.SJXXB + 'sldjpage', _parameter)
  },

  queryDbsj2(_parameter) {// 联动指挥 待办事件-列表
    return sHttp.postJson(_path.SJXXB + 'sldjpage2', _parameter)
  },

  queryDbsj(_parameter) {// 待办事件-列表
    return sHttp.postJson(_path.SJXXB + 'dbsjpage', _parameter)
  },

  queryAllsj(_parameter) {// 全部事件-列表
    return sHttp.postJson(_path.SJXXB + 'allsjpage', _parameter)
  },

  queryYbsj(_parameter) {// 已办事件-列表
    return sHttp.postJson(_path.SJXXB + 'ybsjpage', _parameter)
  },


  detail(_parameter) {// 查询事件 详情
    return sHttp.postJson(_path.SJXXB + 'detail', _parameter)
  },


  dj(_parameter) { // 事件登记
    return sHttp.postJson(_path.SJXXB + 'sjdj', _parameter)
  },
  sl(_parameter) { // 事件受理
    return sHttp.postJson(_path.SJXXB + 'sjsl', _parameter)
  },
  th(_parameter) {    // 事件退回
    return sHttp.postJson(_path.SJXXB + 'sjth', _parameter)
  },
  zb(_parameter) {// 事件转办
    return sHttp.postJson(_path.SJXXB + 'sjzb', _parameter)
  },
  xp(_parameter) { // 事件交办 /下派
    return sHttp.postJson(_path.SJXXB + 'sjjb', _parameter)
  },
  sb(_parameter) { // 事件上报
    return sHttp.postJson(_path.SJXXB + 'sjsb', _parameter)
  },
  bj(_parameter) { // 事件办结
    return sHttp.postJson(_path.SJXXB + 'sjbj', _parameter)
  },
  yq(_parameter) {// 事件延期
    return sHttp.postJson(_path.SJXXB + 'sjyq', _parameter)
  },

}
